"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useERC20Info = exports.useERC20 = void 0;
var react_1 = require("react");
var web3_1 = __importDefault(require("web3"));
var Token_json_1 = __importDefault(require("../abi/Token.json"));
var _abi_1 = require("../abi");
var useContract_1 = require("../contracts/useContract");
var _shared_1 = require("../shared");
var multicall_1 = require("../shared/utils/multicall");
function useERC20(address, web3) {
    return (0, useContract_1.useContract)(Token_json_1.default, address, web3);
}
exports.useERC20 = useERC20;
var erc20PromiseCache = {};
function useERC20Info(address) {
    var _a = (0, _shared_1.useWeb3Provider)(), web3 = _a.targetChainWeb3, targetChain = _a.targetChain;
    var _b = (0, react_1.useState)({
        name: '',
        symbol: '',
        decimals: 0,
    }), info = _b[0], setInfo = _b[1];
    var _c = (0, react_1.useState)(false), isInvalid = _c[0], setIsInvalid = _c[1];
    (0, react_1.useEffect)(function () {
        erc20PromiseCache[address] = undefined;
    }, [targetChain === null || targetChain === void 0 ? void 0 : targetChain.id]);
    (0, react_1.useEffect)(function () {
        if (!web3 || !address) {
            setInfo(undefined);
            return;
        }
        if (!web3_1.default.utils.isAddress(address)) {
            setInfo(undefined);
            setIsInvalid(true);
            return;
        }
        if (erc20PromiseCache[address]) {
            erc20PromiseCache[address].then(setInfo);
            return;
        }
        var methods = {
            name: function (v) { return v; },
            symbol: function (v) { return v; },
            decimals: function (v) { return parseInt(v, 10); },
        };
        erc20PromiseCache[address] = (0, multicall_1.multicallTransformed)({
            web3: web3,
            address: address,
            abi: _abi_1.CONTRACTS.erc20.abi,
            methods: methods,
        })
            .then(function (_a) {
            var name = _a[0], symbol = _a[1], decimals = _a[2];
            return ({
                name: name,
                symbol: symbol,
                decimals: decimals,
            });
        })
            .catch(function (e) {
            console.error('Failed to fetch ERC20 info', e);
            setIsInvalid(true);
        });
        erc20PromiseCache[address].then(setInfo);
    }, [address, web3]);
    return { info: info, isInvalid: isInvalid };
}
exports.useERC20Info = useERC20Info;
